import React from "react";
import { formatUSAmount } from "../../utils/helperFunctions/helperFunctions";
import { useNavigate } from "react-router-dom";

const OrderSummary = ({ total, items_count, setShowPaymentModal }) => {
  const navigate = useNavigate();
  return (
    <div className="max-w-sm border-[#6699C2] border-2 mx-auto bg-white p-6 shadow-lg">
      <h2 className="text-2xl font-bold text-center text-mv-darkblue mb-4">
        ORDER SUMMARY
      </h2>
      <div className="flex justify-between text-lg text-mv-darkblue mb-2">
        <span>Subtotal ({items_count} items) </span>
        <span>${formatUSAmount(total) || 0}</span>
      </div>
      {/* <div className="flex justify-between text-lg text-mv-darkblue mb-2">
        <span>Estimated Taxes</span>
        <span>$##.##</span>
      </div> */}
      <hr className="border-mv-darkblue my-4" />
      <div className="flex justify-between text-lg font-bold text-mv-darkblue mb-4">
        <span>TOTAL</span>
        <span>${formatUSAmount(total) || 0}</span>
      </div>
      <button
        onClick={() => setShowPaymentModal(true)}
        className="w-full bg-mv-darkblue text-white py-2 rounded-lg hover:bg-blue-800 transition duration-300"
      >
        CHECKOUT
      </button>
      <p
        onClick={() => {
          navigate(`/?currentTab=Enhance Sailing`);
        }}
        className="text-center font-semibold text-mv-darkblue mt-4 hover:underline cursor-pointer"
      >
        Continue shopping
      </p>
    </div>
  );
};

export default OrderSummary;
